export default {
    expiryDays: 0,
    openFuturePeriods: 0,
    timelyDays: 15,
};



/** WEBPACK FOOTER **
 ** ./src/model/config/model-defaults/dataSet.js
 **/